import React from 'react';
import PropTypes from 'prop-types';
import { GridRota, GridItem, PointRota, BarRota, NotBarRota, Text } from './styles';

const MilestoneMaker = ({ origem, destino, children }) => (
  <>
    <Text>
      <PointRota />
      {origem}
    </Text>
    <GridRota>
      <BarRota />
      <GridItem>
        {children[0]}
      </GridItem>
    </GridRota>
    <Text>
      <PointRota />
      {destino}
    </Text>
    <GridRota>
      <NotBarRota />
      <GridItem>
        {children[1]}
      </GridItem>
    </GridRota>
  </>
  );

MilestoneMaker.propTypes = {
  origem: PropTypes.string.isRequired,
  destino: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default MilestoneMaker;
